(function () {
  'use strict';

  const BRAND = Object.freeze({
    fontBody: '"Nunito Sans", sans-serif',
    fontHeading: '"Montserrat", sans-serif',
    fontWeightHeading: '400',
    colorText: '#001135',
    colorBorder: '#e2e4e8',
    colorBg: '#f5f5f5',
    accent: '#001135',
    radius: '0px',
    titleTextTransform: 'none',
    titleLetterSpacing: '0',
    freeShippingThreshold: '$90+',
    deliveryBusinessDays: 5,
    returnsWindowDays: 30,
    returnsPolicyUrl: 'https://jockey.com.au/pages/return-and-exchange',
    shippingOptionsUrl: 'https://jockey.com.au/pages/shipping-options',
  });

  const IDS = Object.freeze({
    trustBox: 'poc-trust-box',
    trustStyles: 'poc-trust-box-style',
    shippingCopy: 'poc-shipping-returns-copy',
    lightboxOverlay: 'poc-lightbox-overlay',
    lightboxPanel: 'poc-lightbox-panel',
    lightboxHeader: 'poc-lightbox-header',
    lightboxTitle: 'poc-lightbox-title',
    lightboxClose: 'poc-lightbox-close',
    lightboxBody: 'poc-lightbox-body',
    lightboxStyles: 'poc-lightbox-style',
    shippingLightboxStyles: 'poc-ship-lightbox-style',
  });

  const CHECK_ICON = `
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="3" stroke-linecap="round"
      stroke-linejoin="round" aria-hidden="true" focusable="false">
      <path d="M4 12.5l5 5L20 7"></path>
    </svg>
  `;

  const TRUST_BOX_CSS = `
    #${IDS.trustBox}{
      display:grid;
      grid-template-columns:repeat(2,minmax(0,1fr));
      margin-top:8px;
      overflow:hidden;
      border:1px solid ${BRAND.colorBorder};
      border-radius:${BRAND.radius};
      background:${BRAND.colorBg};
      color:${BRAND.colorText};
      font-family:${BRAND.fontBody};
    }
    #${IDS.trustBox} .poc-trust-cell{
      display:flex;
      align-items:center;
      min-width:0;
      gap:8px;
      padding:8px 10px;
    }
    #${IDS.trustBox} .poc-trust-cell + .poc-trust-cell{
      border-left:1px solid ${BRAND.colorBorder};
    }
    #${IDS.trustBox} .poc-trust-icon{
      display:flex;
      flex:0 0 22px;
      align-items:center;
      justify-content:center;
      width:22px;
      height:22px;
      color:${BRAND.accent};
    }
    #${IDS.trustBox} .poc-trust-text{min-width:0;text-align:left;}
    #${IDS.trustBox} .poc-trust-title{
      color:${BRAND.colorText};
      font-family:${BRAND.fontHeading};
      font-size:13px;
      font-weight:${BRAND.fontWeightHeading};
      letter-spacing:${BRAND.titleLetterSpacing};
      line-height:1.2;
      text-transform:${BRAND.titleTextTransform};
    }
    #${IDS.trustBox} .poc-trust-detail{
      color:${BRAND.colorText};
      font-size:12px;
      line-height:1.25;
    }
    @media (max-width:360px){
      #${IDS.trustBox}{grid-template-columns:1fr;}
      #${IDS.trustBox} .poc-trust-cell + .poc-trust-cell{
        border-top:1px solid ${BRAND.colorBorder};
        border-left:0;
      }
    }
  `;

  const LIGHTBOX_CSS = `
    #${IDS.lightboxOverlay}{
      position:fixed;
      inset:0;
      z-index:9999;
      display:flex;
      align-items:flex-start;
      justify-content:center;
      overflow-y:auto;
      padding:clamp(1rem,4vw,4rem) 1rem;
      background:rgba(0,17,53,.5);
    }
    #${IDS.lightboxPanel}{
      display:flex;
      flex-direction:column;
      width:min(760px,100%);
      max-height:100%;
      border-radius:${BRAND.radius};
      background:#fff;
      color:${BRAND.colorText};
      font-family:${BRAND.fontBody};
    }
    #${IDS.lightboxHeader}{
      display:flex;
      flex:none;
      align-items:center;
      justify-content:space-between;
      gap:1rem;
      padding:1rem 1.25rem;
      border-bottom:1px solid ${BRAND.colorBorder};
    }
    #${IDS.lightboxTitle}{
      margin:0;
      color:${BRAND.colorText};
      font-family:${BRAND.fontHeading};
      font-size:1.05rem;
      font-weight:${BRAND.fontWeightHeading};
      letter-spacing:${BRAND.titleLetterSpacing};
      text-transform:${BRAND.titleTextTransform};
    }
    #${IDS.lightboxClose}{
      padding:.25rem .5rem;
      border:0;
      background:none;
      color:${BRAND.colorText};
      cursor:pointer;
      font-size:1.4rem;
      line-height:1;
    }
    #${IDS.lightboxBody}{padding:1.25rem;overflow-y:auto;}
    #${IDS.lightboxBody}.poc-lightbox-loading{
      padding:2.5rem 1.25rem;
      text-align:center;
      font-size:.95rem;
    }
  `;

  const SHIPPING_LIGHTBOX_CSS = `
    .poc-ship,.poc-ship *{box-sizing:border-box;}
    .poc-ship{font-size:1rem;}
    .poc-ship-facts{
      display:grid;
      grid-template-columns:repeat(2,1fr);
      gap:1px;
      margin:0 0 1.5rem;
      padding:0;
      overflow:hidden;
      border:1px solid ${BRAND.colorBorder};
      border-radius:${BRAND.radius};
      background:${BRAND.colorBorder};
      list-style:none;
    }
    .poc-ship-facts li{margin:0;padding:1rem;background:#fff;}
    .poc-ship-facts strong{display:block;font-size:1rem;}
    .poc-ship-facts span{display:block;margin-top:.2rem;font-size:.85rem;opacity:.68;}
    .poc-ship-cols{display:flex;flex-direction:column;gap:1rem;margin-bottom:1.5rem;}
    .poc-ship-col{padding:1rem 1.25rem;border:1px solid ${BRAND.colorBorder};border-radius:${BRAND.radius};}
    .poc-ship-col h3{margin:0 0 .75rem;font-size:1.15rem;}
    .poc-ship-lead{margin:0 0 .5rem;font-size:1rem;line-height:1.5;}
    .poc-ship-note{margin:.5rem 0 0;font-size:.9rem;line-height:1.5;opacity:.68;}
    .poc-ship-rates{width:100%;border-collapse:collapse;font-size:1rem;}
    .poc-ship-rates th,.poc-ship-rates td{padding:.6rem .3rem;border-bottom:1px solid rgba(127,127,127,.22);text-align:left;}
    .poc-ship-rates th{font-family:${BRAND.fontHeading};font-size:.75rem;font-weight:400;opacity:.75;}
    .poc-ship-rates tr:last-child td{border-bottom:0;}
    @media (max-width:480px){
      .poc-ship-facts{grid-template-columns:1fr;}
      .poc-ship-rates{display:block;overflow-x:auto;white-space:nowrap;}
    }
  `;

  const SHIPPING_LIGHTBOX_MARKUP = `
    <div class="poc-ship">
      <ul class="poc-ship-facts">
        <li><strong>Free for members</strong><span>Not a member? Sign up at checkout</span></li>
        <li><strong>1&ndash;3 day dispatch</strong><span>Longer during sale periods</span></li>
        <li><strong>Up to 7 day delivery</strong><span>Via Australia Post eParcel</span></li>
        <li><strong>Tracked, door to door</strong><span>Emailed the moment it ships</span></li>
        <li><strong>Next business day dispatch</strong><span>May be longer during sale periods</span></li>
        <li><strong>2 day metro delivery</strong><span>Via Australia Post eParcel</span></li>
      </ul>
      <div class="poc-ship-cols">
        <section class="poc-ship-col">
          <h3>Australia</h3>
          <table class="poc-ship-rates">
            <thead>
              <tr><th scope="col">Service</th><th scope="col">Delivery time</th><th scope="col">Under $90</th><th scope="col">$90 &amp; over</th></tr>
              <tr><th scope="col">Service</th><th scope="col">Metro delivery</th><th scope="col">Rural delivery</th><th scope="col">Under $90</th><th scope="col">$90 &amp; over</th></tr>
            </thead>
            <tbody>
              <tr><td>Standard</td><td>Up to 7 business days</td><td>$10.00</td><td>Free</td></tr>
              <tr><td>Express</td><td>1&ndash;3 business days</td><td>$15.00</td><td>$5.00 surcharge</td></tr>
              <tr><td>Standard</td><td>2 business days</td><td>Up to 7 business days</td><td>$10.00</td><td>Free</td></tr>
              <tr><td>Express</td><td>1&ndash;3 business days</td><td>1&ndash;3 business days</td><td>$15.00</td><td>$5.00 surcharge</td></tr>
            </tbody>
          </table>
          <p class="poc-ship-note">Sent via Australia Post or a courier, depending on your location. eGift Cards don't require shipping.</p>
        </section>
        <section class="poc-ship-col">
          <h3>International</h3>
          <p class="poc-ship-lead">Shown at checkout once you enter your address - added to your total before you pay.</p>
          <p class="poc-ship-note">Choose Standard or Priority via Australia Post or a courier. Price and speed depend on destination.</p>
        </section>
      </div>
    </div>
  `;

  let lightboxLastFocused = null;
  let previousBodyOverflow = '';

  function injectStyle(id, css) {
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function retryUntil(check, { tries = 20, interval = 250 } = {}) {
    let attempts = 0;
    const tick = () => {
      if (check() || ++attempts >= tries) return;
      window.setTimeout(tick, interval);
    };
    tick();
  }

  function nextBusinessDay(date) {
      const result = new Date(date);
        do {
            result.setDate(result.getDate() + 1);
              } while (result.getDay() === 0 || result.getDay() === 6);
                return result;
                }

                function addCalendarDays(date, days) {
                  const result = new Date(date);
                    result.setDate(result.getDate() + days);
                      return result;
                      }

                      function formatDeliveryDate() {
                        const dispatchDate = nextBusinessDay(new Date());
                          const deliveryDate = addCalendarDays(dispatchDate, 3);
                            return deliveryDate.toLocaleDateString('en-US', {
                                weekday: 'long', month: 'long', day: 'numeric',
                                  });
                                  }
  
  function createTrustCell(titleText, detailText) {
    const cell = document.createElement('div');
    cell.className = 'poc-trust-cell';

    const icon = document.createElement('div');
    icon.className = 'poc-trust-icon';
    icon.innerHTML = CHECK_ICON;

    const text = document.createElement('div');
    text.className = 'poc-trust-text';

    const title = document.createElement('div');
    title.className = 'poc-trust-title';
    title.textContent = titleText;

    const detail = document.createElement('div');
    detail.className = 'poc-trust-detail';
    detail.textContent = detailText;

    text.append(title, detail);
    cell.append(icon, text);
    return cell;
  }

  function injectTrustBox() {
    if (document.getElementById(IDS.trustBox)) return true;

    const paymentButtons = document.querySelector('.payment-buttons');
    if (!paymentButtons) return false;

    const box = document.createElement('div');
    box.id = IDS.trustBox;
    box.setAttribute('aria-label', 'Shipping information');
    box.append(
      createTrustCell('Members ship free', 'Standard shipping in Australia'),
      createTrustCell('Estimated delivery', `By ${formatDeliveryDate()}`)
    );

    const buttonRow = paymentButtons.closest('.large-row') || paymentButtons;
    buttonRow.insertAdjacentElement('afterend', box);
    return true;
  }

  function findShippingDetails() {
    for (const details of document.querySelectorAll('details')) {
      const headingMatches = Array.from(details.querySelectorAll('*')).some((element) => {
        return element.children.length === 0 && /shipping\s*&\s*returns/i.test(element.textContent || '');
      });
      if (headingMatches) return details;
    }
    return null;
  }

  function createPolicyLink(url, text, title) {
    const link = document.createElement('a');
    link.href = url;
    link.textContent = text;
    interceptAsLightbox(link, title);
    return link;
  }

  function rewriteShippingReturnsPanel() {
    if (document.getElementById(IDS.shippingCopy)) return true;

    const details = findShippingDetails();
    const panel = details && details.querySelector('.cc-accordion-item__panel');
    if (!panel) return false;

    const shippingParagraph = document.createElement('p');
    shippingParagraph.append(
      `Free standard shipping for members and on all orders over ${BRAND.freeShippingThreshold}. See our full `,
      createPolicyLink(BRAND.shippingOptionsUrl, 'shipping options', 'Shipping options'),
      ' for details.'
    );

    const returnsParagraph = document.createElement('p');
    returnsParagraph.append(
      `Change your mind within ${BRAND.returnsWindowDays} days of delivery for a full refund or exchange, if items are unworn with tags attached — underwear (briefs) can only be returned if faulty. Returns are at your own expense (a tracked service is recommended) and need a Return Authorisation Number from us first. Read our full `,
      createPolicyLink(BRAND.returnsPolicyUrl, 'returns and exchange policy', 'Returns & exchanges'),
      '.'
    );

    panel.replaceChildren(shippingParagraph, returnsParagraph);
    panel.id = IDS.shippingCopy;
    return true;
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hidden);
  }

  function closeLightbox() {
    const overlay = document.getElementById(IDS.lightboxOverlay);
    if (!overlay) return;

    overlay.remove();
    document.body.style.overflow = previousBodyOverflow;
    document.removeEventListener('keydown', onLightboxKeydown);

    if (lightboxLastFocused && typeof lightboxLastFocused.focus === 'function') {
      lightboxLastFocused.focus();
    }
  }

  function onLightboxKeydown(event) {
    const overlay = document.getElementById(IDS.lightboxOverlay);
    if (!overlay) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeLightbox();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = getFocusableElements(overlay);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function buildLightbox(title) {
    const overlay = document.createElement('div');
    overlay.id = IDS.lightboxOverlay;
    overlay.addEventListener('mousedown', (event) => {
      if (event.target === overlay) closeLightbox();
    });

    const panel = document.createElement('div');
    panel.id = IDS.lightboxPanel;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', IDS.lightboxTitle);

    const header = document.createElement('div');
    header.id = IDS.lightboxHeader;

    const heading = document.createElement('h2');
    heading.id = IDS.lightboxTitle;
    heading.textContent = title;

    const closeButton = document.createElement('button');
    closeButton.id = IDS.lightboxClose;
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Close');
    closeButton.textContent = '×';
    closeButton.addEventListener('click', closeLightbox);

    const body = document.createElement('div');
    body.id = IDS.lightboxBody;
    body.className = 'poc-lightbox-loading';
    body.setAttribute('aria-live', 'polite');
    body.textContent = 'Loading…';

    header.append(heading, closeButton);
    panel.append(header, body);
    overlay.appendChild(panel);
    return { overlay, body, closeButton };
  }

  function showLoadFailure(body, url) {
    const fallback = document.createElement('p');
    const link = document.createElement('a');
    link.href = url;
    link.textContent = 'View this page';
    fallback.append('Sorry, we couldn’t load this here. ', link, '.');
    body.className = '';
    body.replaceChildren(fallback);
  }

  function openLightbox(url, title) {
    closeLightbox();
    lightboxLastFocused = document.activeElement;
    previousBodyOverflow = document.body.style.overflow;

    const { overlay, body, closeButton } = buildLightbox(title);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onLightboxKeydown);
    closeButton.focus();

    if (url === BRAND.shippingOptionsUrl) {
      injectStyle(IDS.shippingLightboxStyles, SHIPPING_LIGHTBOX_CSS);
      body.className = '';
      body.innerHTML = SHIPPING_LIGHTBOX_MARKUP;
      return;
    }

    fetch(url, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.getElementById('MainContent') || parsed.querySelector('main') || parsed.body;
        source.querySelectorAll('script,style').forEach((element) => element.remove());
        body.className = '';
        body.replaceChildren(document.importNode(source, true));
      })
      .catch(() => showLoadFailure(body, url));
  }

  function interceptAsLightbox(link, title) {
    link.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openLightbox(link.href, title);
    });
  }

  function init() {
    injectStyle(IDS.trustStyles, TRUST_BOX_CSS);
    injectStyle(IDS.lightboxStyles, LIGHTBOX_CSS);
    retryUntil(injectTrustBox);
    retryUntil(rewriteShippingReturnsPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();